import { TextPopup } from "./TextPopup";
import { VideoPopup } from "./VideoPopup";
export default class RTPop {
    constructor() {
        Array.from(document.querySelectorAll(".rt-pop-announcement")).map((e) => this.createPopupFromHTML(e));
    }
    /** @param popupContainer */
    createPopupFromHTML(popupContainer) {
        const popup = popupContainer;
        const { popup_id: id, popup_timeout: rawTimeout = "6000", popup_trigger: trigger, popup_prevent_default: rawPreventDefault, popup_full_width: rawPopupFullWidth, } = popup.dataset;
        const timeout = Number.parseInt(rawTimeout);
        const preventDefault = rawPreventDefault === "on";
        const fullWidth = rawPopupFullWidth === "on";
        if (!id || !trigger) {
            return;
        }
        const data = {
            id,
            timeout,
            trigger,
            preventDefault,
            fullWidth,
        };
        if (popupContainer.querySelector(".rt-video-full-container")) {
            new VideoPopup(data);
        }
        else {
            new TextPopup(data);
        }
    }
    /**
     * @param cookieName
     * @param cookieValue
     * @param minutes
     */
    static setCookie(cookieName, cookieValue, minutes) {
        const d = new Date();
        d.setTime(d.getTime() + minutes * 60 * 1000);
        const expires = "expires=" + d.toUTCString();
        document.cookie =
            cookieName + "=" + cookieValue + ";" + expires + ";path=/";
    }
    /** @param cookieName */
    static getCookie(cookieName) {
        const name = cookieName + "=";
        const decodedCookie = decodeURIComponent(document.cookie);
        const ca = decodedCookie.split(";");
        for (let i = 0; i < ca.length; i++) {
            let c = ca[i];
            while (c.charAt(0) === " ") {
                c = c.substring(1);
            }
            if (c.indexOf(name) === 0) {
                return c.substring(name.length, c.length);
            }
        }
        return "";
    }
}
